<template>
  <div>
    <div class="main_wrap">
    <!-- welcomme message-->
      <div class="welcomme_wrap">
        <div v-if="$i18n.locale=='ko_KR'" class="message">
          {{ $t('sdl.rwd.message.main.welcomeMsg01', [userInfo.userName] ) }}<br>
          <label>{{ $t('sdl.rwd.message.main.welcomeMsg02') }}</label>{{ $t('sdl.rwd.message.main.welcomeMsg03') }}
        </div>
        <div v-if="$i18n.locale=='en_US'" class="message">
          {{ $t('sdl.rwd.message.main.welcomeMsg01', [userInfo.userNameEn] ) }}<br>
          {{ $t('sdl.rwd.message.main.welcomeMsg03') }} &nbsp;<label>{{ $t('sdl.rwd.message.main.welcomeMsg02') }}</label>
        </div>
        <div>
          <router-link to="/about/GCRM" class="btn_gcrm">GCRM {{ $t('sdl.gcrm.main.what.is') }}</router-link>
        </div>
      </div>
    <!-- //welcomme message-->
      <div class="mainCon_wrap">
        <div class="main_leftCon">
          <div  :class="isViewAll ? 'quick_wrap open' : 'quick_wrap'">
              <div class="main_tit">Quick Link</div>
              <ul>
                  <!--1번째줄-->
                  <li v-for="(menu, index) in swipers" v-if="index<4 && menu.iconClass!=''" :class="menu.iconClass" @click="setExternalUrl(menu)">
                      <p class="quickicon"></p>
                      <p class="quick_txt">{{ getLabel(menu) }}</p>
                  </li>
              </ul>
              <div class="view_quick">
                  <ul>
                        <!--2번째줄-->
                      <li v-for="(menu, index) in swipers" v-if="index>3 && menu.iconClass!=''" :class="menu.iconClass" @click="setExternalUrl(menu)">
                          <p class="quickicon"></p>
                          <p class="quick_txt">{{ getLabel(menu) }}</p>
                      </li>
                  </ul>
              </div>
          </div>
          <div class="quick_btn_wrap" @click="viewAllMenu()">
              <div :class="isViewAll ? 'quick_btn close' : 'quick_btn more'">
                  <a v-if="!isViewAll" id="quick_more">{{ $t('sdl.rwd.btn.more') }}</a>
                  <a v-if="isViewAll" id="quick_more">{{ $t('sdl.rwd.btn.close') }}</a>
              </div>
          </div>
          <div class="banner_wrap">
              <!-- <div class="Inquiry">
                  <div>
                      <p class="banner_GCRM_tit">{{ $t('sdl.rwd.main.GCRMPortalInquiry') }}</p>
                      <label>gcrm.prd@samsung.com</label>
                  </div>
                  <div>
                      <p class="banner_Rewards_tit">{{ $t('sdl.rwd.main.RewardsInquiry') }}</p>
                      <label>rewards.sec@samsung.com </label>
                  </div>
                  <div>
                      <p class="banner_campaign_tit">Campaign Inquiry </p>
                      <label>campaign.prd@samsung.com </label>
                  </div>
              </div> -->
              <div class="ITvoc">
                <a href="http://itvoc.sec.samsung.net" target="_blank">
                      <p class="banner_ITvoc_tit">{{ $t('sdl.gcrm.common.goToItVocHome') }}</p>
                </a>
                <label>{{ $t('sdl.gcrm.common.goToVocMain') }}</label>
              </div>
          </div>
        </div>
          <!-- right  -->
        <div class="main_rightCon">
          <!-- Notice -->
          <div class="notice_wrap">
            <div class="main_tit">
              {{ $t('sdl.main.message.notice') }}
              <router-link to="/about/notice/list" class="btn more">{{ $t('sdl.gcrm.common.viewMore.details')  }}</router-link>
            </div>
            <ul class="news-list">
              <li v-for="item in gridList" :key="item.number" :class="{ visited: $getVisited(tableId, item.noticeId) }">
                <span class="state-label General" :class="{ primary: Number(item.importantYn) ? true : false }">
                  {{ !Number(item.importantYn) ? $t('sdl.gcrm.common.general') : $t('sdl.gcrm.common.important') }}
                </span>
                <div class="tit">
                  <a href="javascript:void(0)" class="text-truncate" @click="getNoticeItem(item.noticeId)">
                    {{ item.title }}
                  </a>
                </div>
                <div class="date">{{ item.firstRegDatetime | dateFormat($t('data-format.date.ymd')) }}</div>
              </li>
            </ul>
          </div>
          <!--// Notice -->
          <!-- Request for data -->
          <div class="Request" v-if="(userInfo.compCode !== 'PC2')">
            <div class="Request_tit_warp">
              <span class="Request_tit">{{ $t('sdl.gcrm.common.requestForData') }}</span>
              <span class="Request_infor" :data-tooltip="$t('sdl.rwd.message.main.tooltipMsg') "></span>
            </div>
            <div class="Request_btn_wrap">
                <router-link to="/voc/datareq/dataWrite" class="btn btn-primary btn-md">
                  {{ $t('sdl.gcrm.common.requestData') }}
                </router-link>
                <router-link to="/voc/datareq/dataList" class="btn btn-primary btn-md">
                  {{ $t('sdl.gcrm.common.requestStatus') }}
                </router-link>
            </div>
          </div>
          <!--// Request for data -->
        </div>
      </div>
    </div>


      <!-- 슬라이드 --><!-- 2022-09-19 매 클릭시점에서 키파람을 새로 만들어야 한다.-->
      <!-- <div class="service-wrap">
        <div class="inner">
          <div class="service-slide">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="slide in swipers" :key="slide.code">
                <a href="javascript:void(0)" @click="setExternalUrl(slide)">
                  <span class="im"><img :src="slide.description.icon" alt="" /></span>
                  <p class="txt">{{ getLabel(slide) }}</p>
                </a>
              </swiper-slide>
            </swiper>
            <button type="button" class="swiper-button swiper-button-prev" slot="button-prev"></button>
            <button type="button" class="swiper-button swiper-button-next" slot="button-next"></button>
          </div>
        </div>
      </div> -->
      <!-- //슬라이드 -->


    <form ref="keyParamFormMain" name="keyParamFormMain"
       method="post" target="newWin2">
      <input type="hidden" name="key_param" v-model="key_param" />
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { SDLUtil, StringUtil } from '@/utils';
import SDLLocale from '@/mixin/SDLLocale';
import 'swiper/css/swiper.css';
import NoticePopupVue from '@/components/common/popup/NoticePopup';

export default {
  mixins: [SDLLocale],
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      tableId: 'mainNotice',
      gridList: [],
      swipers: [],
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.service-slide .swiper-button-next',
          prevEl: '.service-slide .swiper-button-prev',
        },
      },
      userInfo: {}, // jwt token 정보
      link: '',
      iconClasses: [
        'loyalty',
        'campaign',
        'operation',
        'admin',
        'it-admin',
        'coupon',
        'dashboard',
        'rewards',
        'report',
        'analytics',
      ],
      key_param: null,
      isViewAll: false,
    };
  },
  async created() {
    this.swipers = await this.getIconList();
    await this.getPostList();
    this.userInfo = SDLUtil.getLoginedUserInfo();
  },
  methods: {
    ...mapGetters({
      getAuthInfo: 'getAuthInfo',
      getHighestRole: 'getHighestRole',
    }),
    async getIconList() {
      const res = await axios.get(`${SDLUtil.API_URL}/gcrm/common/home-icon`).catch(err => {
        console.log(err);
      });
      if (res && res.status === 200 && res.data) {
        const homeIconList = [...res.data.homeIconList];
        homeIconList.forEach(el => {
          try {
            el.description = JSON.parse(el.description);
            el.iconClass = this.matchingIcon(el);
          } catch (error) {
            console.log('JSON parse Error : ', el.description);
          }
        });
        return _.sortBy(homeIconList, ['ord']);
      }
      return [];
    },
    async getNoticeItem(noticeId) {
      SDLUtil.show(
        NoticePopupVue,
        { noticeId },
        {
          width: '860px',
          height: 'auto',
        },
      );
    },
    async getPostList() {
      let params = {
        pageSize: 5,
      };
      params = _.omit(params, _.isNull); // Remove null from parameter items
      SDLUtil.showLoadingBar(true);
      const res = await axios
        .get(`${SDLUtil.API_URL}/gcrm/about/notice/list-with-paging?${StringUtil.queryStringfy(params)}`)
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
          return err.response;
        });
      if (res.status === 200) {
        this.gridList = res.data.rows;
      }
      SDLUtil.showLoadingBar(false);
    },
    async setExternalUrl(item) {
      if (Number(item.description.key_param_flag)) {
        // let keyParam = '';
        // 빈 문자열로 전달하는 경우 => 로그인한유저녹스아이디 + "|" + 클릭시각(요청시간)의 데이터를 암호화 하여 리턴한다.

        /*
        const keyRes = await axios.post(`${SDLUtil.API_URL}/gcrm/seed/encrypt`, { data: '' }).catch(err => {
          console.log(err);
        });
        if (keyRes && keyRes.status === 200 && !_.isEmpty(keyRes.data)) {
          // keyParam = keyRes.data.data;
          // window.open(`${item.description.url}?key_param=${keyParam}`);
          this.key_param = keyRes.data.data;
          this.$refs.keyParamFormMain.action = item.description.url;
          this.$refs.keyParamFormMain.submit();
        } else {
          SDLUtil.errorAlert();
        }
*/
        axios.post(`${SDLUtil.API_URL}/gcrm/seed/encrypt`, { data: '' })
          .then(({ data }) => {
            this.key_param = data.data; // key_param
            this.$refs.keyParamFormMain.key_param.value = data.data;
            // console.log(this.key_param);
            // console.log(item.regionCodeDescription.url);
            // console.log(this.$refs.keyParamFormHeader.key_param.value);
            this.$refs.keyParamFormMain.action = item.description.url;
            this.$refs.keyParamFormMain.submit();
          })
          .catch(err => {
            console.error(err);
            SDLUtil.showLoadingBar(false);
            SDLUtil.errorAlert(err);
          });
      } else {
        window.open(item.description.url);
      }
    },
    matchingIcon(str) {
      const orginLabel = str.label.toLowerCase();
      let iconClass = '';
      this.iconClasses.forEach(item => {
        if (orginLabel.indexOf(item) > -1) {
          iconClass = `quick_box ${item}`;
        }
      });
      return iconClass;
    },
    viewAllMenu() {
      this.isViewAll = !this.isViewAll;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainIndexPage.vue